import React, { Fragment } from 'react';
import "./responses.css";
import Response from "../../components/response/response-component";
import Spinner from "../../components/spinner/spinner-component";
import Paginator from "../../components/paginator/paginator-component";


const ResponsesComponent = (
  {
    responses,
    page,
    totalPages,
    loading,
    changePage,
    error,
    showContextMenu,
    setSelectedText
  }
) => {
  return (
    <div className="responses_module_container shadow">
      <div
        style={{
          borderBottom: '1px solid #e0e0d9'
        }}
        className="responses_module_container__header"
      >
        <div className="responses_module_container__header__title">
          <span>Responses</span>
        </div>
        <div className="responses_module_container__header__paginator">
          <Paginator
            changePage={changePage}
            page={page}
            data={responses}
            totalPages={totalPages}
          />
        </div>
      </div>

      {
        !loading && !error ?
          responses[page].map((response, i)=> (
          <Response
            key={i}
            header={response.header}
            value={response.value}
            terms={response.terms}
            hbIndex={response.hb_index}
            primaries={response.primaries}
            score={response.score}
            showContextMenu={showContextMenu}
            setSelectedText={setSelectedText}
          />
        ))
          :
          loading ?
          <Spinner
            loading={loading}
            marginTop="20px"
          />
            :
            error ?
              <span style={{alignSelf: 'center'}}>{error}</span>
              :
              null
      }
      {
        !loading && !error && responses[page].length
          ?
          <div
            className="responses_module_container__header"
            style={{
              flexDirection: 'row-reverse'
            }}
          >
            <div className="responses_module_container__header__paginator">
              <Paginator
                changePage={changePage}
                page={page}
                data={responses}
                totalPages={totalPages}
                callback={() => {
                  window.scrollTo({
                    top: 1144,
                    behavior: 'smooth'
                  })
                }}
              />
            </div>
          </div>
          :
          null
      }
    </div>
  )
};

export default ResponsesComponent


// WEBPACK FOOTER //
// ./src/modules/responses/responses-component.js